<template>
  <div class="row">
    <div class="col pb-3">
      <div v-if="!busy" class="row">
        <div v-if="!onlyShowSearch" class="col-lg-8">
          <b-tabs
            v-model="selectorType"
            content-class="bg-white"
          >
            <b-tab
              :title="$t('Select coverage on map')"
              :title-link-class="'first-tab'"
              lazy
            >
              <div v-if="!isMobile" class="expandable-wrapper__menu position-absolute d-flex p-3 justify-content-end">
                <span class="cursor-pointer" @click="$refs.map.expand()">
                  <font-awesome-icon icon="expand-alt" />
                </span>
              </div>
              <postcode-map ref="map" v-model="selectedPostcodes" />
            </b-tab>
            <b-tab
              :title="$t('Select by postcode')"
              :title-link-class="'last-tab'"
            >
              <postcode-search v-model="selectedPostcodes" />
            </b-tab>
          </b-tabs>
        </div>
        <div v-if="!showBasket && onlyShowSearch" class="col-12 pb-3 mb-lg-0">
          <b-card
            no-body
            class="bg-white rounded border shadow"
          >
            <b-card-header class="d-flex justify-content-between align-items-center">
              {{ 'Search for postcodes' }}
            </b-card-header>
            <postcode-search v-model="selectedPostcodes" />
          </b-card>
        </div>
        <div v-if="isDesktop || showBasket" class="col-12 col-xxl-4 mb-5">
          <b-card :class="['bg-white', 'rounded', 'shadow', 'border']" no-body>
            <b-card-header>{{ $t('Postcodes Added') }}</b-card-header>
            <basket v-model="selectedPostcodes" />
          </b-card>
        </div>
      </div>
      <spinner v-else :display-loading="!savingPostcodeCoverage" :saving="savingPostcodeCoverage" />
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/animation/Spinner";
import PostcodeMap from "@/components/tabs/coverage/postcodes/PostcodeMap";
import PostcodeSearch from "@/components/tabs/coverage/postcodes/PostcodeSearch";
import Basket from "@/components/tabs/coverage/postcodes/Basket";
import userDevice from "@/imports/mixins/userDevice";

export default {
  name: "Postcodes",
  components: {Basket, PostcodeSearch, Spinner, PostcodeMap},
  mixins: [userDevice],
  props: ['coverage'],
  data: function () {
    return {
      dataLoaded: 1,
      selectorType: 0,
      selectedPostcodes: [],
      savingPostcodeCoverage: false,
      initial: true,
      cleanState: true,
      showBasket: false,
    }
  },
  computed: {
    busy: function() {
      return this.dataLoaded < 1;
    },
    coveragePostCodes: function() {
      return this.$store.state.coverage.COVERAGE_POST_CODES;
    },
    preventSave: function() {
      return this.selectedPostcodes.length < 1 || this.busy;
    },
    onlyShowSearch: function() {
      return !this.isDesktop;
    }
  },
  methods: {
    selectType: function(type) {
      this.selectorType = type;
    },
    updateCoverageSelectorType: function() {
      if (this.isMobile) {
        this.selectorType = 1;
      }
    },
    savePostCodes: async function() {
      this.savingPostcodeCoverage = true;
      this.dataLoaded--;
      this.$api.coverage.updatePostCodes(this.coverage.id, this.selectedPostcodes).then(() => {
        this.$store.dispatch('updateGlobals');
        this.$emit('complete');
        this.loadCoveragePostCodes();
        this.dataLoaded++
        this.$emit('isSaving', true);
      });
    },
    loadCoveragePostCodes: function() {
      this.dataLoaded--;
      this.$store.dispatch('getCoveragePostCodes', this.coverage.id).then(() => {this.dataLoaded++});
    },
    save: function() {
      this.savePostCodes();
    },
    switchBasket: function() {
      this.showBasket = !this.showBasket;
    }
  },
  watch: {
    coverage: function() {
      this.loadCoveragePostCodes();
    },
    coveragePostCodes: function() {
      this.initial = true;
      this.selectedPostcodes = [...this.coveragePostCodes];
      this.selectedPostcodes.sort((a,b) => a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}));
    },
    selectedPostcodes: function() {
      if(this.initial) {
        this.initial = false;
        this.cleanState = true;
      } else {
        this.cleanState = false;
      }
    },
    cleanState: function(value) {
      this.$emit('clean', value);
    }
  },
  created: function() {
    this.loadCoveragePostCodes();
    this.updateCoverageSelectorType();
  },
}
</script>

<style scoped lang="scss">
.expandable-wrapper__menu {
  right: 20px;
  z-index: 10;
}
</style>
